import { useEffect, useState, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useToast } from '@/shared/hooks'
import { useApiQuery } from '@/api/main/query'
import {
  requisiteAPI,
  RequisiteModel,
  requisiteStatisticApi,
  RequisiteStatisticModel,
} from '@/features/requisites'
import { PaginatedCollection } from '@/api/types'

type BankStatus = 'stopped' | 'canceled' | 'active' | 'new'

export const useRequisitPageData = () => {
  const { id } = useParams<{ id: string }>()
  const { addToast } = useToast()

  const [requisitData, setRequisitData] = useState<RequisiteModel>()

  const {
    data: queryRequisitData,
    error: requisitError,
    isLoading: requisitIsLoad,
  } = useApiQuery<RequisiteModel>(['requisit', id], requisiteAPI.getRequisit(id ?? ''), undefined, {
    enabled: !!id,
  })

  useEffect(() => {
    if (queryRequisitData) {
      setRequisitData({ ...queryRequisitData })
    }
  }, [queryRequisitData])

  useEffect(() => {
    if (requisitError) {
      addToast('Ошибка!', requisitError.message, 'error')
    }
  }, [requisitError])

  const status: BankStatus = useMemo(() => {
    if (requisitData?.isBlocked) return 'stopped'
    if (requisitData?.isDeleted) return 'canceled'
    if (requisitData?.isDisabledByUser) return 'stopped'
    return 'active'
  }, [requisitData?.isBlocked, requisitData?.isDeleted, requisitData?.isDisabledByUser])

  // Общая статистика по реквизиту
  const {
    data: requisiteStatData,
    error: requisiteStatError,
    isLoading: requisiteStatIsLoad,
  } = useApiQuery<PaginatedCollection<RequisiteStatisticModel[]>>(
    ['requisite-total-stat', id],
    requisiteStatisticApi.getTotalStat(`ids=${id}`),
    undefined,
    { enabled: !!id }
  )

  return {
    id,
    queryRequisitData,
    requisitData,
    setRequisitData,
    requisitIsLoad,
    requisitError,
    requisiteStatData,
    requisiteStatError,
    requisiteStatIsLoad,
    status,
  }
}
